function confirmConWA (payload) {
    var WA = `Estimado/a ${payload.patient_name}:\n\nSu cita se agendó exitosamente:\n\nFecha: ${payload.date}\nHora: ${payload.time}\nDoctor/a: ${payload.doctor_name}\nConsulta ID: ${payload.event_id} \n\n Para su comodidad y seguridad llena el formulario obligatorio aqui:\n`
    return WA
}

export { confirmConWA }